import { render } from "./TgAwsSecureUploader.vue?vue&type=template&id=0bd7aa5f"
import script from "./TgAwsSecureUploader.vue?vue&type=script&lang=js"
export * from "./TgAwsSecureUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__